// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"85a8d955","219":"50cc7bc1"}[chunkId] + ".chunk.css";
};